// Case-insensitive URL param getter (reads from window.location.search)
export const getParamCaseInsensitive = (name: string): string => {
    const params = new URLSearchParams(window.location.search);
    for (const [key, value] of params.entries()) {
        if (key.toLowerCase() === name.toLowerCase()) return value;
    }
    return "";
};

// Common EHR params
export const getEhrUserId = () => getParamCaseInsensitive("userId");
export const getPatientId = () => getParamCaseInsensitive("patId");
